import(/* webpackMode: "eager" */ "/home/sangapus/Documents/projects/vscode-projects/trade-certification-main/apps/dfe/app/error.tsx");
